export interface UserKycState {
  status: KycStatus;
  isValid: boolean;
  isIdentityCardValid: boolean;
  isAddressValid: boolean;
  addressStatus: KycAddressStatus;
  hasNfcCard: boolean;
  addressVerificationStatus: KycAddressVerificationStatus;
  requiresManualAddress: boolean;
  hasUsableAddress: boolean;
  isProofPendingVerification: boolean;
  requiresProofOfAddress: boolean;
  isKycComplete: boolean;
}

export interface UserKyc {
  status: KycStatus;
  session: UserKycSession;
  identityCard: UserIdentityCard;
  address: UserAddress;
}

export interface UserKycSession {
  id: string;
  providerName: KycProvider;
  token: string;
  isExpired: boolean;
}

export type KycProvider = 'mock' | 'sumsub';

export const KycStatus = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Submitted: 'Submitted',
  ReviewRequired: 'ReviewRequired',
  Valid: 'Valid',
  Invalid: 'Invalid',
  Expired: 'Expired',
} as const;

export const KycAddressStatus = {
  InProgress: 'InProgress',
  Valid: 'Valid',
  Invalid: 'Invalid',
  NotRequired: 'NotRequired',
} as const;

export const KycAddressVerificationStatus = {
  NotRequired: 'NotRequired',
  Unverified: 'Unverified',
  PendingVerification: 'PendingVerification',
  Verified: 'Verified',
  Rejected: 'Rejected',
} as const;

export type KycAddressVerificationStatus =
  (typeof KycAddressVerificationStatus)[keyof typeof KycAddressVerificationStatus];

export type KycStatus = (typeof KycStatus)[keyof typeof KycStatus];
export type KycAddressStatus =
  (typeof KycAddressStatus)[keyof typeof KycAddressStatus];

export interface UserIdentityCard {
  id: string;
  timestamp: Date;
  firstName: string;
  lastName: string;
  cnp: string;
  serialCode: string;
  serialNumber: string;
  birthDate: Date;
  gender: string;
  fullAddress: string;
  expireDate: Date;
  isValid: boolean;
  isExpired: boolean;
  blobProtectedLink: string;
  blobName: string;
  sideBlobProtectedLink: string | null;
  sideBlobName: string | null;
}

export type ProofOfAddressDocumentType = 'certificate' | 'invoice';

export interface UploadProofOfAddressRequest {
  file: File;
  documentType: ProofOfAddressDocumentType;
}

export interface UpdateAddressRequest {
  countyName: string;
  localityType: string;
  localityName: string;
  street: string;
  streetNumber: string;
  entrance: string;
  floor: string;
  apartment: string;
  sector: string;
  building: string;
}

export interface UserAddress {
  apartment: string | null;
  building: string | null;
  city: string | null;
  commune: string | null;
  countyCode: string | null;
  countyId: string | null;
  countyName: string | null;
  fullAddress: string | null;
  id: string;
  isValid: boolean;
  locality: string | null;
  localityId: string | null;
  localityTypeId: string | null;
  localityTypeName: string | null;
  sector: string | null;
  street: string | null;
  streetNumber: string | null;
  streetType: string | null;
  userId: string;
  village: string | null;
}
